import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowLeft, User, Users } from 'lucide-react';
export function ApparelsPage() {
  return <div className="min-h-screen font-sans" style={{
    backgroundColor: '#0D121D'
  }} data-id="element-109">
      <Header data-id="element-110" />

      <main className="pt-32 pb-24 min-h-screen" data-id="element-111">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-112">
          <a href="/" className="inline-flex items-center text-slate-300 hover:text-white transition-colors mb-12" data-id="element-113">
            <ArrowLeft className="w-5 h-5 mr-2" data-id="element-114" />
            Back to Home
          </a>

          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-115">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-116">
              Twice Bourne Apparels
            </h1>
            <p className="text-2xl text-slate-300 mb-4" data-id="element-117">
              Custom-made fashion for twins, tailored by hand
            </p>
            <p className="text-lg text-slate-400" data-id="element-118">
              High-end fabric and garments, focusing on making matching apparels
              for twins. Where comfort meets sophisticated design.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-119">
            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-slate-500 transition-colors p-10 flex flex-col items-center text-center" data-id="element-120">
              <div className="w-20 h-20 rounded-full bg-white/10 flex items-center justify-center mb-8 text-white" data-id="element-121">
                <User className="w-10 h-10" data-id="element-122" />
              </div>
              <h2 className="text-3xl font-bold text-white mb-4" data-id="element-123">
                Twice Bourne Clothing
              </h2>
              <div className="inline-block px-4 py-1 rounded-full bg-slate-800 text-slate-300 text-sm font-medium mb-6" data-id="element-124">
                Men's Line
              </div>
              <p className="text-slate-300 text-lg" data-id="element-125">
                Premium, sustainably sourced clothing designed specifically for
                the modern man.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-slate-500 transition-colors p-10 flex flex-col items-center text-center" data-id="element-126">
              <div className="w-20 h-20 rounded-full bg-white/10 flex items-center justify-center mb-8 text-white" data-id="element-127">
                <Users className="w-10 h-10" data-id="element-128" />
              </div>
              <h2 className="text-3xl font-bold text-white mb-4" data-id="element-129">Fabritwins</h2>
              <div className="inline-block px-4 py-1 rounded-full bg-slate-800 text-slate-300 text-sm font-medium mb-6" data-id="element-130">
                Women's Line
              </div>
              <p className="text-slate-300 text-lg" data-id="element-131">
                Elegant, hand-tailored fashion focusing on beautiful matching
                sets for twins.
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-132" />
    </div>;
}